import { render, staticRenderFns } from "./product_video_dialog.vue?vue&type=template&id=9f1c63d0"
import script from "./product_video_dialog.vue?vue&type=script&lang=js"
export * from "./product_video_dialog.vue?vue&type=script&lang=js"
import style0 from "./product_video_dialog.vue?vue&type=style&index=0&id=9f1c63d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports